import request from '@/utils/request'
// 登陆接口
export function plat_login(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
// 退出登陆
export function plat_logout(data) {
    return request({
        url: '/logout',
        method: 'post',
        data
    })
}
// 平台统计
export function plat_index_account(data) {
    return request({
        url: '/index/account',
        method: "get",
        params: data,
    })
}
// 图表数据
export function plat_index_list(data) {
    return request({
        url: '/index/list',
        method: "get",
        params: data,
    })
}
// 日志列表
export function plat_log_list(data) {
    return request({
        url: '/log/list',
        method: "get",
        params: data,
    })
}
// 账户信息
export function plat_info_index(data) {
    return request({
        url: '/info/index',
        method: "get",
        params: data,
    })
}
// 修改账户信息
export function plat_info_modify(data) {
    return request({
        url: '/info/modify',
        method: 'post',
        data
    })
}
// 账户列表
export function plat_account_list(data) {
    return request({
        url: '/account/list',
        method: "get",
        params: data,
    })
}
// 账户创建或修改
export function plat_account_save(data) {
    return request({
        url: '/account/save',
        method: 'post',
        data
    })
}
// 删除账户
export function plat_account_delete(data) {
    return request({
        url: '/account/delete',
        method: 'post',
        data
    })
}
// 禁用账户
export function plat_account_disable(data) {
    return request({
        url: '/account/disable',
        method: 'post',
        data
    })
}
// 云模板列表
export function plat_account_template_index(data) {
    return request({
        url: '/account/template/index',
        method: "get",
        params: data,
    })
}
// 修改模板权限
export function plat_account_template_change(data) {
    return request({
        url: '/account/template/change',
        method: 'post',
        data
    })
}
// 组件列表
export function plat_account_app_index(data) {
    return request({
        url: '/account/app/index',
        method: "get",
        params: data,
    })
}
// 修改账户组件权限
export function plat_account_app_change(data) {
    return request({
        url: '/account/app/change',
        method: 'post',
        data
    })
}
// 跳转token
export function plat_account_token(data) {
    return request({
        url: '/account/token',
        method: "get",
        params: data,
    })
}
// 创建版本更新
export function log_version_save(data) {
    return request({
        url: '/log/version/save',
        method: 'post',
        data
    })
}
// 版本更新日志列表
export function version_index(data) {
    return request({
        url: '/log/version/index',
        method: "get",
        params: data,
    })
}
// 删除版本更新
export function version_delete(data) {
    return request({
        url: '/log/version/delete',
        method: 'post',
        data
    })
}
// 修改授权状态
export function auth_change(data) {
    return request({
        url: '/auth/change',
        method: 'post',
        data
    })
}
// 授权列表
export function auth_index(data) {
    return request({
        url: '/auth/index',
        method: "get",
        params: data,
    })
}
// 创建授权
export function auth_save(data) {
    return request({
        url: '/auth/save',
        method: 'post',
        data
    })
}
// 删除授权
export function auth_delete(data) {
    return request({
        url: '/auth/delete',
        method: 'post',
        data
    })
}
// 版本下拉
export function version_select(data) {
    return request({
        url: '/version/select',
        method: "get",
        params: data,
    })
}
// 账户的版本列表
export function account_version(data) {
    return request({
        url: '/account/version',
        method: "get",
        params: data,
    })
}
// 删除账户版本
export function account_version_delete(data) {
    return request({
        url: '/account/version/delete',
        method: 'post',
        data
    })
}
// 编辑账户版本
export function account_version_edit(data) {
    return request({
        url: '/account/version/edit',
        method: 'post',
        data
    })
}
// 续费
export function account_version_renew(data) {
    return request({
        url: '/account/version/renew',
        method: 'post',
        data
    })
}
// 增加码量
export function version_add_nums(data) {
    return request({
        url: '/account/version/add_nums',
        method: 'post',
        data
    })
}
// 新建或修改版本
export function version_save(data) {
    return request({
        url: '/version/save',
        method: 'post',
        data
    })
}
// 版本列表
export function version(data) {
    return request({
        url: '/version',
        method: "get",
        params: data,
    })
}
// 版本上架或下架
export function version_change(data) {
    return request({
        url: '/version/change',
        method: 'post',
        data
    })
}
// 版本等级
export function version_last_grade(data) {
    return request({
        url: '/version/last_grade',
        method: "get",
        params: data,
    })
}
// 版本删除
export function version_del(data) {
    return request({
        url: '/version/del',
        method: 'post',
        data
    })
}
// 序号
export function version_sort(data) {
    return request({
        url: '/version/sort',
        method: "get",
        params: data,
    })
}
// 插件下拉
export function account_app_select(data) {
    return request({
        url: '/account/app/select',
        method: "get",
        params: data,
    })
}
// 溯源码版本列表
export function version_qrcode(data) {
    return request({
        url: '/version/qrcode',
        method: "get",
        params: data,
    })
}
// 新建或修改溯源码版本
export function version_qrcode_save(data) {
    return request({
        url: '/version/qrcode/save',
        method: 'post',
        data
    })
}
// 修改溯源码版本上下架
export function version_qrcode_change(data) {
    return request({
        url: '/version/qrcode/change',
        method: 'post',
        data
    })
}
// 删除溯源码版本
export function version_qrcode_del(data) {
    return request({
        url: '/version/qrcode/del',
        method: 'post',
        data
    })
}
// 溯源码版本最后序号
export function version_qrcode_sort(data) {
    return request({
        url: '/version/qrcode/sort',
        method: "get",
        params: data,
    })
}
// 插件版本列表
export function version_apps(data) {
    return request({
        url: '/version/apps',
        method: "get",
        params: data,
    })
}
// 新建或修改插件版本
export function version_apps_save(data) {
    return request({
        url: '/version/apps/save',
        method: 'post',
        data
    })
}
// 插件版本最后序号
export function version_apps_sort(data) {
    return request({
        url: '/version/apps/sort',
        method: "get",
        params: data,
    })
}
// 修改插件版本上下架
export function version_apps_change(data) {
    return request({
        url: '/version/apps/change',
        method: 'post',
        data
    })
}
// 删除插件版本
export function version_apps_del(data) {
    return request({
        url: '/version/apps/del',
        method: 'post',
        data
    })
}
// 账户下拉
export function account_select(data) {
    return request({
        url: '/account/select',
        method: "get",
        params: data,
    })
}
// 版本的订单列表
export function plat_order_version(data) {
    return request({
        url: '/order/version',
        method: "get",
        params: data,
    })
}
// 下单购买版本
export function order_version_buy(data) {
    return request({
        url: '/order/version/buy',
        method: 'post',
        data
    })
}
// 下单购买溯源码套餐
export function order_qrcode_buy(data) {
    return request({
        url: '/order/qrcode/buy',
        method: 'post',
        data
    })
}
// 下单购买插件
export function order_apps_buy(data) {
    return request({
        url: '/order/apps/buy',
        method: 'post',
        data
    })
}
// 获取版本下单信息
export function order_version_price(data) {
    return request({
        url: '/order/version/price',
        method: 'post',
        data
    })
}
// 关于我们 保存或更新
export function other_about_save(data) {
    return request({
        url: '/other/about/save',
        method: 'post',
        data
    })
}
// 关于我们 获取
export function other_about(data) {
    return request({
        url: '/other/about',
        method: "get",
        params: data,
    })
}
// 获取单个文档
export function help_content_one(data) {
    return request({
        url: '/help/content/one',
        method: "get",
        params: data,
    })
}
// 文档列表
export function help_content(data) {
    return request({
        url: '/help/content',
        method: "get",
        params: data,
    })
}
// 创建文档
export function help_content_save(data) {
    return request({
        url: '/help/content/save',
        method: 'post',
        data
    })
}
// 删除文档
export function help_content_delete(data) {
    return request({
        url: '/help/content/delete',
        method: 'post',
        data
    })
}
// 分类列表
export function help_category(data) {
    return request({
        url: '/help/category',
        method: "get",
        params: data,
    })
}
// 获取排序
export function help_category_sort(data) {
    return request({
        url: '/help/category/sort',
        method: "get",
        params: data,
    })
}
// 创建分类
export function help_category_save(data) {
    return request({
        url: '/help/category/save',
        method: 'post',
        data
    })
}
// 删除分类
export function help_category_delete(data) {
    return request({
        url: '/help/category/delete',
        method: 'post',
        data
    })
}
// 插件版本详情
export function version_apps_version_info(data) {
    return request({
        url: '/version/apps/version_info',
        method: "get",
        params: data,
    })
}
// 退款
export function order_refund(data) {
    return request({
        url: '/order/refund',
        method: 'post',
        data
    })
}
// 溯源码版本下拉
export function version_qrcode_select(data) {
    return request({
        url: '/version/qrcode/select',
        method: "get",
        params: data,
    })
}
// 插件版本下拉
export function version_apps_select(data) {
    return request({
        url: '/version/apps/select',
        method: "get",
        params: data,
    })
}
// 版本详情
export function version_infos(data) {
    return request({
        url: '/version/infos',
        method: "get",
        params: data,
    })
}
// 修改案例状态
export function cases_status(data) {
    return request({
        url: '/cases/status',
        method: 'post',
        data
    })
}
// 案例排序
export function cases_sort(data) {
    return request({
        url: '/cases/sort',
        method: "get",
        params: data,
    })
}
// 创建案例
export function cases_save(data) {
    return request({
        url: '/cases/save',
        method: 'post',
        data
    })
}
// 删除案例
export function cases_delete(data) {
    return request({
        url: '/cases/delete',
        method: 'post',
        data
    })
}
// 文章案例
export function cases_list(data) {
    return request({
        url: '/cases/list',
        method: "get",
        params: data,
    })
}
// 反馈信息列表
export function feedback_list(data) {
    return request({
        url: '/feedback',
        method: "get",
        params: data,
    })
}

export function version_apps_info(data) {
    return request({
        url: '/version/apps/info',
        method: "get",
        params: data,
    })
}